<template>
    <!--Duy edit 06/02/2024-->
    <!-- <div class="input-text">
        <div class="row mb-2">
            <label v-if="title && title.trim().length > 0" for="" class="col-12 col-form-label text-sm" style="">
                {{ title }} <span class="text-danger">{{ isRequire ? '(*)' : '' }}</span>
            </label>
            <div class="col-12">
                <textarea v-if="isMultipleLine == true" type="text" class="form-control" :placeholder="placeholder" v-model="model" :readonly="isReadOnly || false" @input="$emit('update:modelValue', $event.target.value)" :class="{ 'is-invalid': error }" rows="3"></textarea>
                <input v-if="isMultipleLine == null || isMultipleLine == false" type="text" class="form-control" :placeholder="placeholder" v-model="model" :readonly="isReadOnly || false" @input="$emit('update:modelValue', $event.target.value)" :class="{ 'is-invalid': error }"/>
            </div>
        </div>
        <div class="text-danger text-right mb-2" style="margin-top: -13 !important;" v-if="error">
            {{ error }}
        </div>
    </div> -->
    <div class="form-group">
        <label v-if="title && title.trim().length > 0">
            {{ title }} <span class="text-danger">{{ isRequire ? '(*)' : '' }}</span>
        </label>
        <textarea v-if="isMultipleLine == true" type="text" class="form-control" :placeholder="placeholder"
            v-model="model" :readonly="isReadOnly || false" @change="onChange" :class="{ 'is-invalid': error }" rows="2"
            autocomplete="off"></textarea>
        <input v-else ref="input" :type="type ? type : 'text'" class="form-control" :placeholder="placeholder"
            v-model="model" :readonly="isReadOnly || false" @change="onChange" :class="{ 'is-invalid': error }"
            autocomplete="off" />
        <div class="text-danger text-right" v-if="error">
            {{ error }}
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { ref, toRefs } from "vue";
export default {
    components: {

    },
    name: "TheInputText",
    props: {
        title: String,
        initialValue: String,
        placeholder: String,
        error: String,
        type: String,
        isReadOnly: Boolean,
        isRequire: Boolean,
        isMultipleLine: Boolean,

    },
    methods: {
        onChange(e) {
            this.$emit('update:modelValue', e.target.value)
            this.$emit('onChange', e.target.value)
        }
    },
    setup(props) {
        const model = ref("");
        let { initialValue } = toRefs(props);
        model.value = initialValue.value;

        var inputs = document.querySelectorAll("input");
        inputs.forEach(function (input) {
            input.setAttribute("autocomplete", "off");
        });


        return { model };
    },
}
</script>